import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  textStyle: {
    fontSize: 10,
    letterSpacing: -0.04,
    lineHeight: 1.44,
    color: '#3a3b3f'
  },
  horizontalContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  rectangle: {
    width: 4,
    height: 16,
    borderRadius: 8.5,
    backgroundColor: '#DEDE664C',
    marginRight: 3
  },
  textStep: {
    fontSize: 10,
    letterSpacing: -0.04,
    lineHeight: 1.44,
    color: '#858d9c',
    marginRight: 5
  }
}));

export default useStyles;
